module.exports = __webpack_public_path__ + "img/message.04dae690.svg";